<template>
  <v-row align="center">
    <v-col cols="12">
      <v-row no-gutters align="center">
        <v-col cols="3" class="text-right mr-3">
          {{ $t("agenda.lblStartTime") }}:
        </v-col>
        <v-col cols="2" class="text-left">
          <v-row no-gutters align="center">
            <ejs-timepicker
              :value="startTime"
              :showClearButton="false"
              :change="onStartTimeChange"
              :strictMode="true"
              :enableMask="true"
              :openOnFocus="true"
              :format="dateFormat"
            ></ejs-timepicker>
          </v-row>
        </v-col>
        <v-col cols="2" class="text-right pr-3">
          {{ $t("agenda.lblEndTime") }}:
        </v-col>
        <v-col cols="2" class="text-left">
          <end-time-picker
            :value="endTime"
            :minimumDate="startTime"
            @change="onEndTimeChange"
          ></end-time-picker>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { TimePickerComponent } from "@syncfusion/ej2-vue-calendars";
import EndTimePicker from "./EndTimePicker.vue";

export default {
  name: "StartEndTime",
  components: {
    "ejs-timepicker": TimePickerComponent,
    EndTimePicker,
  },
  props: {
    startDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    endDate: {
      type: [String, Date],
      default: () => new Date(),
    },
  },
  data() {
    return {
      minEndDate: new Date(),
      timeStep: 60,
      timeFormat: "HH:mm",
      timeVal: new Date(),
      selectedTime: null,
      minTime: null,
      maxTime: null,
    };
  },
  mounted() {
    this.setMinMaxTime();
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.locale !== "ja" ? "" : "HH:mm";
    },
    startTime() {
      return this.startDate ? new Date(this.startDate) : new Date();
    },
    endTime() {
      return this.endDate ? new Date(this.endDate) : new Date();
    },
  },
  methods: {
    onStartTimeChange,
    onEndTimeChange,
    AddMinutesToDate,
    setMinMaxTime() {
      const currentDate = new Date();
      const currentHour = currentDate.getHours();
      const currentMinute = currentDate.getMinutes();

      // Calculate next hour
      let nextHour = currentHour + 1;
      if (nextHour >= 24) {
        nextHour = 0; // Reset to 0 if it's 24 or higher
      }

      this.minTime = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        currentHour,
        currentMinute
      );
      this.maxTime = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        nextHour,
        currentMinute
      );
    },
  },
};

function onStartTimeChange(event) {
  if (event.event) {
    if (event.value) {
      const date = new Date(event.value);
      this.$emit("update:startDate", date);
      // if (new Date(this.endDate).getTime() <= date.getTime()) {
      const newDate = this.AddMinutesToDate(new Date(date), 120).toISOString();
      this.$emit("update:endDate", newDate);
    } else {
      this.$emit("update:startDate", new Date());
    }
    // }
  } else {
    this.$emit("update:startDate", new Date());
  }
}

function onEndTimeChange(updatedDate) {
  if (updatedDate) {
    const endDate = new Date(updatedDate);
    let date = endDate;
    // if (endDate.getTime() <= new Date(this.startDate).getTime()) {
    //   date = this.AddMinutesToDate(
    //     new Date(endDate.toISOString()),
    //     120
    //   ).toISOString();
    // }
    this.$emit("update:endDate", new Date(date));
  } else {
    const newDate = this.AddMinutesToDate(
      new Date(this.startDate),
      120
    ).toISOString();
    this.$emit("update:endDate", newDate);
  }
}

function AddMinutesToDate(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}
</script>

<style scoped>
::v-deep .e-time-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 40px;
  font-size: 13px !important;
  margin-bottom: 0px !important;
}

::v-deep .e-time-wrapper .e-input-group-icon {
  min-height: 18px !important;
  min-width: 18px !important;
}

</style>